export enum TipoUsuarioEnum {
  CONADE = 1,
  INSTITUTO = 2,
  COORDINADOR = 3,
  PROMOTOR = 4,
  CONSULTA = 5,
  EMBAJADOR = 4,
  Embajador= 'Embajador',
  coordinadorRuta = 'coordinador',
  promotorRuta= 'promotor',
  Coordinador = 'Coordinador',
  Promotor = 'Promotor',
  Consulta = 'Consulta',
  UsuOIC = 1095,
  tipoPromotor = 'Promotor'
}
